import { HStack } from '@urbantxt/layout';
import React, { useEffect } from 'react';
import { TableProvider } from '@urbantxt/table';

import NotesButton from 'features/labs/components/NotesButton/NotesButton';
import ViewContactLogCell from 'features/scla/components/table/ViewContactLogCell';
import SclaViewAppCell from 'features/scla/components/table/SclaViewAppCell';
import useWindowSize from 'hooks/useWindowSize';
import useRsuiteTableA11yPatches from 'hooks/useRsuiteTableA11yPatches';
import { formatTableDateTime } from 'services/moment.service';
import { BooleanTag } from '@urbantxt/tag';

type Props = {
  children: React.ReactNode;
};

export default function TableProviderRosie({ children }: Props) {
  useEffect(() => {
    // Feature routes register cells via side-effect imports; provider supplies host UI.
  }, []);

  return (
    <TableProvider
      config={{
        formatDateTime: formatTableDateTime,
        components: {
          HStack,
          BooleanTag,
          IsActiveTag: BooleanTag,
          NotesButton,
        },
        hooks: {
          useWindowSize,
          useRsuiteTableA11yPatches,
        },
        legacyActionCells: {
          contactLog: ViewContactLogCell,
          viewApp: SclaViewAppCell,
        },
      }}
    >
      {children}
    </TableProvider>
  );
}
